export default {
'odkryj_dostep': 'Odkryj wszystkie kategorie i ciesz się pełnym dostępem.',
'odkryj_dostep_opis': 'Opłatę wnosi tylko jeden gracz i odblokowuje grę dla obojga!',
'kontynuuj_gre': 'Kontynuuj grę',
'zacznij_od_nowa': 'Zacznij od nowa',
'dolacz_do_gry': 'Dołącz do gry',
'prosze_czekac': 'Proszę czekać',
'polski': 'Polski',
'angielski': 'English',
'hiszpanski': 'Español',
'wloski': 'Italiano',
'francuski': 'Français',
'portugalski': 'Português',
'niemiecki': 'Deutsch',
'zamknij': 'Zamknij',
'start_gry': "Start gry",
'graj': 'Graj',
'wpisz_imiona_graczy':'Wpisz imiona graczy',
'twoje_imie':'Twoje imię',
'imie_drugiego_gracza' :'Imię drugiego gracza',
'wyslij_zaproszenie': 'Wyślij zaproszenie',
'konfiguracja_polaczenia': 'Konfigurowanie połączenia',
'daj_drugiemu': "Daj drugiemu graczowi do zeskanowania poniższy kod",
'poziomy': 'Kategorie',
'rozpocznij_gre': 'Rozpocznij grę',
'poziom1': 'Poziom 1',
'poziom2': 'Poziom 2',
'poziom3': 'Poziom 3',
'oczekuje_na_druga_osobe': 'Oczekuje na odpowiedź drugiej osoby',
'oczekuje_na_druga_osobe_2': 'Oczekuje na drugą osobę',
'graj_dalej': 'Graj dalej',
'dokoncz_gre': 'Dokończ grę',
'odpowiadaj_na_pytania': 'Odpowiadaj na pytania',
'pytanie': 'Pytanie',
'z':'z',
'oczekuje_na_osobe': 'Oczekuje na odpowiedź drugiej osoby',
'wyniki_rozgrywki': "Wyniki rozgrywki",
'gratulacje': "Gratulacje",
'macie_zgodnosc': "Macie zgodność",
'znasz_grugiego_gracza': "Znasz drugiego gracza na",
'zna_ciebie': "zna Ciebie na",
'jak_odpowiadaliscie': 'Zobacz jak odpowiadaliście',
'pochwal_sie': 'Pochwal się wynikiem',
'wasze_odpowiedzi': "Wasze odpowiedzi",
'skanuj_kod':"Skanuj kod",
'statystyka': "Statystyka",
'statystyka_gry': "Statystyka rozgrywki",
'powiadom': 'Powiadom o nowej wersji',
'zapisalismy_cie': 'Zapisaliśmy Twoj adres e-mail',
'rozpocznij': 'Rozpocznij',
'poznajcie_sie': "Poznajcie się",
'jak_znasz': "Pasujące Połówki to gra dla par, która umożliwi sprawdzenie jak dobrze znasz swojego partnera, a jak on Ciebie.",
'help1': "Masz już zaczętą grę. Jeżeli chcesz ją kontynuować - naciśnij poniższy guzik.",
'help2': "Chcesz jednak zacząć grę od nowa lub z nowym graczem - naciśnij poniższy guzik.",
'help3': "Jako pierwszy z graczy skonfiguruj grę - dodaj imiona graczy i daj drugiemu graczowi do zeskanowania wygenerowany kod.",
'help4': "Po wygenerowaniu kodu przez pierwszego z graczy naciśnij poniższy guzik i zeskanuj kod.",
'help5': "Po wpisaniu imion graczy, naciśnij guzik \"Wyślij zaproszenie\" i daj do zeskanowania wygenerowany kod drugiemu z graczy.",
'help6': "Daj drugiemu graczowi do zeskanowania poniższy kod",
'help7': "Zeskanuj kod wygenerowany przez drugiego gracza",
'kup': "Kup",
'zagraj_ponownie': 'Zagraj ponownie',
'opis_gry': 'Opis gry',
'poziom': 'Poziom',
'ext_desc': '<br>Pasujące Połówki to gra dla par, która umożliwi sprawdzenie jak dobrze znasz swojego partnera, a jak on Ciebie.<br><br>Gracie online w jednym czasie na dwóch urządzeniach. Oboje musicie pobrać grę ze sklepu.<br><br>Jedna z osób rozpoczyna grę klikając w guzik "Rozpocznij grę" i wpisuje Wasze imiona.<br><br>Druga z osób dołącza do gry klikając w guzik "Dołącz do gry" i skanuje kod wygenerowany przez osobę rozpoczynającą grę. Po zeskanowaniu kodu, obu graczom wyświetli się start gry i kategorie.<br><br>Aplikacja posiada 6 kategorii, w każdej są 3 poziomy trudności. Zaczynacie od najłatwiejszego, czyli poziomu 1 (ukończenie 1 poziomu - umożliwia rozpoczęcie kolejnego).<br><br>Niech Was nie zniechęcą z pozoru proste pytania, bo im dalej w las będzie coraz ciężej i pikantniej!<br><br>W tym samym czasie na Waszych telefonach lub tabletach pokaże się to samo pytanie, na które odpowiadacie tak / nie lub zaznaczacie konkretną odpowiedź. Waszym zadaniem jest wyłącznie kliknąć na poprawną odpowiedź.<br><br>Najpierw odpowiadasz co myśli Twój partner, potem odpowiadasz za siebie co Ty myślisz. Po każdym poziomie możecie sprawdzić jak odpowiadaliście i jaką macie zgodność procentową.<br><br>W każdym momencie możecie przerwać grę i dokończyć ją w późniejszym terminie, ale w przypadku gdy rozpoczniecie grę od nowa, Wasze dotychczasowe odpowiedzi zostają usunięte.<br><br>Życzymy miłej zabawy!<br><br><br><br><br><br>',
'druga_osoba_odpowiedziala': 'Druga osoba czeka na Twoją odpowiedź',
'confirm_text_1': 'Chcesz zacząć grę od nowa?',
'confirm_text_2': 'Stracisz swoje poprzednie odpowiedzi.',
'yes_button': 'Tak, zaczynam od nowa',
'no_button': 'Nie, gram dalej',
'back' : 'wróć',
'backk' : 'Powrót',
'podsumowanie_wynikow': 'Podsumowanie wyników',
			
'Życie codzienne': 'Życie codzienne',
'Daily life': 'Życie codzienne',
'La vida cotidiana': 'Życie codzienne',
'Vie courante': 'Życie codzienne',
'Alltagsleben': 'Życie codzienne',
'Vita di ogni giorno': 'Życie codzienne',
'Vida cotidiana': 'Życie codzienne',
			
'Osobowość / charakter': 'Osobowość / charakter',
'Personalità/carattere': 'Osobowość / charakter',
'Personality / character': 'Osobowość / charakter',
'Caracter personal': 'Osobowość / charakter',
'Caractère de la personnalité': 'Osobowość / charakter',
'Personalidade / personagem': 'Osobowość / charakter',
'Persönlichkeit Charakter': 'Osobowość / charakter',
			
'Życie towarzyskie': 'Życie towarzyskie',
'Social life': 'Życie towarzyskie',
'Vida social': 'Życie towarzyskie',
'Vie sociale': 'Życie towarzyskie',
'Soziales Leben': 'Życie towarzyskie',
'Vita sociale': 'Życie towarzyskie',
			
'Wyznawane wartości': 'Wyznawane wartości',
'Values / beliefs': 'Wyznawane wartości',
'Valores propugnados': 'Wyznawane wartości',
'Valeurs adoptées': 'Wyznawane wartości',
'Valores expostos': 'Wyznawane wartości',
'Vertraute Werte': 'Wyznawane wartości',
'Valori sposati': 'Wyznawane wartości',
			
'Nałogi / nawyki': 'Nałogi / nawyki',
'Habits / Addictions': 'Nałogi / nawyki',
'Adicciones / hábitos': 'Nałogi / nawyki',
'Dépendances / habitudes': 'Nałogi / nawyki',
'Vícios / hábitos': 'Nałogi / nawyki',
'Süchte / Gewohnheiten': 'Nałogi / nawyki',
'Dipendenze/abitudini': 'Nałogi / nawyki',
			
'Seks':'Seks',
'Sex':'Seks',
'Sexo':'Seks',
'Sexe':'Seks',
'Sesso':'Seks',
			
'wpisz_imiona': 'Wpisz imiona obu graczy',
'wpisz_rozne_imiona': 'Wpisz imiona różniące się od siebie',
'odblokowane': 'Wszystkie poziomy zostały odblokowane. Grajcie dalej!',

'jasny': 'Jasny',
'ciemny': 'Ciemny',

'blad_polaczenia': "Błąd połączenia. Spróbuj ponownie.",
'przekaz_kod_gry': "Twój kod gry",
'przekaz_kod_gry_drugi_gracz': "Możesz również przekazać kod gry dla drugiego gracza",
"skanuj_kod_aparatem": "Skanuj kod aparatem",
"wpisz_kod_recznie": "Wpisz kod ręcznie",
"wprowadz_kod": "Wprowadź otrzymany kod",
"wprowadz_kod_gry": "Wprowadź kod gry",
"help8": "W poniższe pole wpisz kod gry otrzymany od drugiego gracza. To jego wpisaniu gra uruchomi się automatycznie",
"nieprawidlowy_kod_gry": "Podany kod jest nieprawidłowy",
'powrot_do_kategorii': 'Powrót do kategorii'
}